import React from "react";
import styles from "./styles.module.scss";

const Header: React.FC = () => {
  return (
    <header className={styles.header}>
      <h1 className={styles.headerContent}>Overview mode</h1>
    </header>
  );
};

export default Header;
